export const initialState = () => ({
  visits: {
    data: [
      {}, // set new entry
    ],
  },
  catalog: {
    academicYears: [],
    previousAcademicYears: [],
    months: [],
    monthsOriginal: [],
    services: [],
    centers: [],
    locationsType: [],
    locations: [],
    visitTypes: [],
    documentTypes: [],
    practitioners: [],
    visitAbsenceRegistration: [],
    replacements: [],
    repositions: [],
    specialistsReplacement: [],
    visitLocations: [],
    visitRegions: [],
    visitDistricts: [],
    visitSchools: [],
    visitMunicipalities: [],
    visitLocationServices: [],
    visitCenters: [],
    specialists: [],
    supervisedSpecialists: [],
    providers: [],
  },
  filter: {
    academicYear: null,
    month: null,
    isAdminOrSpecialist: false,
    specialist: null,
    provider: null,
    service: null,
    center: null,
    locationType: null,
    location: null,
    age: null,
    action: null,
    sie: null,
    results: null,
  },
  currentFilter: {
    academicYear: null,
    month: null,
    isAdminOrSpecialist: false,
    specialist: null,
    provider: null,
    service: null,
    center: null,
    placeType: null,
    place: null,
    age: null,
    action: null,
    results: null,
  },
  paging: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
  },
  configPaginated: {
    pageSize: 15,
  },
  filteredPeriod: {},
  isPeriodFinalized: false,
  selectedPeriod: null,
  selectedVisitFilter: {
    academicYear: null,
    month: null,
    provider: null,
    specialist: null,
    center: null,
    service: null,
    location: null,
    age: null,
    action: null,
    sie: null,
    supervisedSpecialist: null,
    isAdminOrSpecialist: false,
    locationType: null,
    academicYearId: null,
  },
});

export const state = initialState();
